module.exports = __webpack_public_path__ + "static/media/amazing_ringtone.91a55347.mp3";